import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'

import { HistoryDialogModule } from '../history-dialog'
import { PatientInsuranceHistoryDialogComponent } from './patient-insurance-history-dialog.component'

@NgModule({
  imports: [
    CommonModule,
    HistoryDialogModule,
    TranslateModule,
  ],
  declarations: [
    PatientInsuranceHistoryDialogComponent,
  ],
})
export class PatientInsuranceHistoryDialogModule {}
